export default __webpack_public_path__ + "static/hw_ff_bme280-05621a7a886271760f0e39a4fd9b116a.png";